import React from 'react'
import Form from 'react-bootstrap/Form';
import Col from 'react-bootstrap/Col'

const AirTightness = (props) => {
    return (
        <Form.Row>
            <Col xs={2} lg={2}>
                <Form.Control plaintext readOnly defaultValue={props.code} />
            </Col>

            <Col xs={5} lg={2}>
                <Form.Group controlId={`air_tightness[${props.air_tightness_id}][cost]`}>
                    <Form.Control
                        lang="en"
                        step="any"
                        name="cost"
                        type="number"
                        onChange={(e) => props.changeFunc(e, props.air_tightness_id)}
                        value={props.cost}
                    />
                </Form.Group>
            </Col>

            <Col xs={4} lg={2}>
                <Form.Group controlId={`air_tightness[${props.air_tightness_id}][n50]`}>
                    <Form.Control
                        lang="en"
                        step="any"
                        name="n50"
                        disabled
                        onChange={(e) => props.changeFunc(e, props.air_tightness_id)}
                        value={props.n50}
                    />
                </Form.Group>
            </Col>
        </Form.Row>
    );
}

export default AirTightness